export const THEME_BREAKPOINTS = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "75em", // 1200px
  xl: "80em",
  "2xl": "96em",
};
